import type { FlattenSimpleInterpolation } from 'styled-components'
import styled, { css } from 'styled-components'

import { spacing } from '@vfuk/core-mixins'

import type { StyledSnippetProps } from './Snippet.style.types'

type SnippetProps = Pick<StyledSnippetProps, 'theme' | 'justify' | 'inverse'>
export const Snippet = styled.div(
  (props: SnippetProps): FlattenSimpleInterpolation => css`
    text-align: ${props.justify};
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    justify-content: space-between;

    ${props.inverse &&
    css`
      color: ${props.theme.color.monochrome1.default};
    `}
  `,
)

type SnippetTextWrapperProps = Pick<StyledSnippetProps, 'hasButton'>
export const SnippetTextWrapper = styled.div(
  (props: SnippetTextWrapperProps): FlattenSimpleInterpolation => css`
    ${props.hasButton &&
    css`
      ${spacing('margin-bottom', 3)}
    `}
  `,
)

export const InteractionWrapper = styled.div((): FlattenSimpleInterpolation => css``)
